import { datadogRum } from "@datadog/browser-rum";
import { version } from "@root/package.json";
import { isDev } from "@/lib/env";

export function setupDatadog() {
  if (!isDev) {
    datadogRum.init({
      applicationId: "355bb805-720d-430b-9f11-ae752aaeeb6e",
      clientToken: "pub86514b29742a0f92e027d1413fc7df47",
      site: "datadoghq.com",
      service: "embeds",
      env: isDev ? "development" : "production",
      version,
      sessionSampleRate: 0.1,
      sessionReplaySampleRate: 0.1,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    datadogRum.startSessionReplayRecording();
  }
}
